export default __webpack_public_path__ + "static/media/422.648e0dec.png";